import type { SetOrderParameterInput } from "@repo/api/schemas";
import { type AnsweringDeclaration, answerFromField } from "@repo/data-store";
import { answeredValueProblem, type IntegerDeclaration, type QuantityDeclaration } from "@repo/domain";

/** Blank fields clear an answer; numeric zero and boolean false remain answers. */
export function orderParameterAnswer(declaration: AnsweringDeclaration, raw: unknown): SetOrderParameterInput["value"] {
  const answer = answerFromField(declaration, typeof raw === "boolean" ? String(raw) : raw);
  return answer?.kind === "Choice" ? { ...answer, selected: [...answer.selected] } : (answer ?? null);
}

/** Why an answer cannot be saved, so a number field can say so instead of clamping it. */
export function orderParameterProblem(
  parameter: {
    label: string;
    value: QuantityDeclaration | IntegerDeclaration | { kind: "Choice" | "Boolean" | "Text" };
  },
  raw: unknown,
): string | undefined {
  const declaration = parameter.value;
  if (declaration.kind !== "Quantity" && declaration.kind !== "Integer") return undefined;
  const answer = answerFromField(declaration, raw);
  const problem = answer ? answeredValueProblem(declaration, answer) : undefined;
  return problem ? `${parameter.label} ${problem}` : undefined;
}
